// extracted by mini-css-extract-plugin
export var numpadContainer = "_o2-1";
export var phoneButton = "_o2-0";